/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FinanceTaskIcon1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Tysiav2FinanceTaskIcon from 'DesignSystem/Svgs/Tysiav2FinanceTaskIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FinanceTaskIcon1({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/Icon/Tysiav2FinanceTaskIcon",
  height,
  width
  
}) {
let iconColorValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'color',
})
  return (<React.Fragment
>
<Tysiav2FinanceTaskIcon
  viewPath={`${viewPath}/Tysiav2FinanceTaskIcon`}
 data="icon.color"
 fill2={iconColorValueData}
 height={height}
 width={width}
/>
{children}
</React.Fragment>)
}